export const FACILITY_FORMS = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityName", "facilityTypeId", "ownerPartyId", "FacilitySize", "description" ]
        } ],
        "columns" : [ {
            "name" : "facilityId",
            "title" : "Facility ID"
        }, {
            "name" : "facilityName",
            "title" : "Facility Name"
        }, {
            "name" : "facilityTypeId",
            "title" : "Facility Type"
        }, {
            "name" : "ownerPartyId",
            "title" : "Owner"
        }, {
            "name" : "FacilitySize",
            "title" : "Area"
        }, {
            "name" : "description",
            "title" : "Description"
        } ],
        "formName" : "FindFacility",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Facility ID",
            "type" : "HYPERLINK",
            "target" : "EditFacility",
            "name" : "facilityId",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            } ],
            "style" : "",
            "id" : "FindFacility_facilityId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event":"custom",
            "formData":{
                "formName":"EditFacility",
                "formLocation":"component://kwikstore/widget/FacilityForms.xml",
                "link":"/admin/facilities/facility/${facilityId}/facility-overview/custom"
            }
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityName",
            "description" : "",
            "style" : "",
            "id" : "FindFacility_facilityName",
            "title" : "Facility Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityTypeId",
            "description" : "",
            "style" : "",
            "id" : "FindFacility_facilityTypeId",
            "title" : "Facility Type",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "ownerPartyId",
            "description" : "",
            "style" : "",
            "id" : "FindFacility_ownerPartyId",
            "title" : "Owner",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "FacilitySize",
            "description" : "",
            "style" : "",
            "id" : "FindFacility_FacilitySize",
            "title" : "Area",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "FindFacility_description",
            "title" : "Description",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityTypeId", "parentFacilityId", "ownerPartyId", "defaultWeightUomId", "defaultInventoryItemTypeId", "facilityName", "facilitySize", "facilitySizeUomId", "description", "defaultDaysToShip", "submitButton" ]
        } ],
        "formName" : "EditFacility",
        "altTarget" : [ {
            "useWhen" : "parameters.facility==null",
            "targetExdr" : {
            "chars" : "CreateFacility",
            "hint" : 20,
            "empty" : false,
            "original" : "CreateFacility"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "EditFacility_facilityId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "WebStoreWarehouse"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "facilityId",
            "description" : "WebStoreWarehouse",
            "style" : "",
            "id" : "EditFacility_facilityId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "Facility Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFacility",
            "options" : [ {
            "description" : "Building",
            "key" : "BUILDING"
            }, {
            "description" : "Call Center",
            "key" : "CALL_CENTER"
            }, {
            "description" : "Floor",
            "key" : "FLOOR"
            }, {
            "description" : "Office",
            "key" : "OFFICE"
            }, {
            "description" : "Plant",
            "key" : "PLANT"
            }, {
            "description" : "Retail Store",
            "key" : "RETAIL_STORE"
            }, {
            "description" : "Room",
            "key" : "ROOM"
            }, {
            "description" : "Warehouse",
            "key" : "WAREHOUSE"
            } ],
            "disabled" : "false",
            "id" : "EditFacility_facilityTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "facilityTypeId",
            "style" : "",
            "explicitDescription" : "Warehouse",
            "choices" : "",
            "currentValue" : "WAREHOUSE"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditFacility",
            "id" : "EditFacility_parentFacilityId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupFacility",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "parentFacilityId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "parentFacilityId",
            "style" : "",
            "id" : "EditFacility_parentFacilityId",
            "title" : "Parent Facility ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditFacility",
            "id" : "EditFacility_ownerPartyId",
            "event" : "",
            "value" : "Company",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "ownerPartyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "ownerPartyId",
            "style" : "",
            "id" : "EditFacility_ownerPartyId",
            "title" : "Owner",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Default Weight Unit",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFacility",
            "options" : [ {
            "description" : "None",
            "key" : ""
            }, {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            } ],
            "disabled" : "false",
            "id" : "EditFacility_defaultWeightUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "defaultWeightUomId",
            "style" : "",
            "explicitDescription" : "Pound (avdp)",
            "choices" : "",
            "currentValue" : "WT_lb"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Default Inventory Item Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFacility",
            "options" : [ {
            "description" : "None",
            "key" : ""
            }, {
            "description" : "Non-Serialized",
            "key" : "NON_SERIAL_INV_ITEM"
            }, {
            "description" : "Serialized",
            "key" : "SERIALIZED_INV_ITEM"
            } ],
            "disabled" : "false",
            "id" : "EditFacility_defaultInventoryItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "defaultInventoryItemTypeId",
            "style" : "",
            "explicitDescription" : "Non-Serialized",
            "choices" : "",
            "currentValue" : "NON_SERIAL_INV_ITEM"
        }, {
            "" : "Web Store Warehouse",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "facilityName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacility_facilityName",
            "placeholder" : "",
            "event" : "",
            "value" : "Web Store Warehouse",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Area",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "facilitySize",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacility_facilitySize",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Area Unit",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFacility",
            "options" : [ {
            "description" : "None",
            "key" : ""
            } ],
            "disabled" : "false",
            "id" : "EditFacility_facilitySizeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "facilitySizeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "Warehouse exclusively for the Web Store",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Product Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacility_description",
            "placeholder" : "",
            "event" : "",
            "value" : "Warehouse exclusively for the Web Store",
            "mask" : ""
        }, {
            "" : "25",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Default Days To Ship",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "defaultDaysToShip",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacility_defaultDaysToShip",
            "placeholder" : "",
            "event" : "",
            "value" : "25",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditFacility",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditFacility_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "UpdateFacility"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "facilityId", "contactMechTypeId", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "contactMechTypeId",
            "title" : "Contact Mech Type ID"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ViewContactMechs",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "ViewContactMechs_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "ViewContactMechs_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WebStoreWarehouse"
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Contact Mech Type ID",
            "type" : "HYPERLINK",
            "target" : "ViewGatewayResponse",
            "name" : "contactMechTypeId",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "contactMechId",
                "bracketedOriginal" : "${contactMechId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "contactMechId"
            },
            "name" : "contactMechId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "contactMechTypeId",
                "bracketedOriginal" : "${contactMechTypeId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "contactMechTypeId"
            },
            "name" : "contactMechTypeId"
            } ],
            "style" : "",
            "id" : "ViewContactMechs_contactMechTypeId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "CommonRemove",
            "parameterList" : [ {
            "name" : "facilityId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "ViewContactMechs_deleteLink",
            "imageTitle" : "",
            "parameterMap" : {
            "facilityId" : "WebStoreWarehouse"
            },
            "height" : "",
            "target" : "deleteContactMech"
        } ],
        "target" : "deleteContactMech?facilityId=${facilityId}&contactMechId=${contactMechId}"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "totalAvailableToPromise", "totalQuantityOnHand", "quantityOnOrder", "minimumStock", "reorderQuantity", "daysToShip", "offsetQOHQtyAvailable", "offsetATPQtyAvailable", "quantityUom", "usageQuantity", "defaultPrice", "listPrice", "wholeSalePrice", "fromDateSellThrough", "sellThroughInitialInventory", "sellThroughInventorySold", "sellThroughPercentage" ]
        } ],
        "columns" : [ {
            "name" : "items",
            "title" : "Product ID"
        }, {
            "name" : "productId",
            "title" : "Description"
        }, {
            "name" : "totalAvailableToPromise",
            "title" : "Total ATP"
        }, {
            "name" : "totalQuantityOnHand",
            "title" : "Total QOH"
        }, {
            "name" : "quantityOnOrder",
            "title" : "Ordered Quantity"
        }, {
            "name" : "minimumStock",
            "title" : "Minimum Stock"
        }, {
            "name" : "reorderQuantity",
            "title" : "Reorder Quantity"
        }, {
            "name" : "daysToShip",
            "title" : "Days To Ship"
        }, {
            "name" : "offsetQOHQtyAvailable",
            "title" : "QOH minus Min Stock"
        }, {
            "name" : "offsetATPQtyAvailable",
            "title" : "ATP minus Min Stock"
        }, {
            "name" : "quantityUom",
            "title" : "Quantity UomId"
        }, {
            "name" : "usageQuantity",
            "title" : "Usage"
        }, {
            "name" : "defaultPrice",
            "title" : "Default Price"
        }, {
            "name" : "listPrice",
            "title" : "List Price"
        }, {
            "name" : "wholeSalePrice",
            "title" : "Whole Sale Price"
        }, {
            "name" : "fromDateSellThrough",
            "title" : "From Date Sell Through"
        }, {
            "name" : "sellThroughInitialInventory",
            "title" : "Sell Through Initial Inventory"
        }, {
            "name" : "sellThroughInventorySold",
            "title" : "Sell Through Inventory Sold"
        }, {
            "name" : "sellThroughPercentage",
            "title" : "Sell Through Percentage"
        } ],
        "formName" : "ListFacilityInventoryByProduct",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product ID",
            "type" : "HYPERLINK",
            "target" : "EditFacilityInventoryItems",
            "name" : "items",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "facilityId"
            } ],
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_items",
            "imageTitle" : "",
            "parameterMap" : {
            "facilityId" : "WebStoreWarehouse"
            },
            "height" : "",
            "formData":{
                "formName":"EditFacilityInventoryItems",
                "formLocation":"component://kwikstore/widget/FacilityForms.xml"
            },
            "event":"list"
        }, {
            "hyperlink" : {
            "linkStyle" : "buttontext",
            "description" : "Catalog",
            "targetType" : "inter-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_bd2bf61e_beea_4076_a816_b3d11ca798be",
            "target" : "/catalog/control/EditProduct",
            "targetWindow" : "",
            "remoteFormData":{
                "formData":{
                    "formName":"EditProduct",
                    "formLocation":"component://kwikstore/widget/FacilityForms.xml"
                }
            }
            },
            "event":"edit",
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_productId",
            "title" : "CommonDescription",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : "",
        }, {
            name:"quantities",
            title:"Quantities",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "totalAvailableToPromise",
                    "title" : "Total ATP"
                }, {
                    "name" : "totalQuantityOnHand",
                    "title" : "Total QOH"
                }, {
                    "name" : "quantityOnOrder",
                    "title" : "Ordered Quantity"
                }, {
                    "name" : "minimumStock",
                    "title" : "Minimum Stock"
                }, {
                    "name" : "reorderQuantity",
                    "title" : "Reorder Quantity"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalAvailableToPromise",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_totalAvailableToPromise",
            "title" : "CommonTotal ATP",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "totalQuantityOnHand",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_totalQuantityOnHand",
            "title" : "CommonTotal QOH",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityOnOrder",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_quantityOnOrder",
            "title" : "Ordered Quantity",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "minimumStock",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_minimumStock",
            "title" : "Minimum Stock",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "reorderQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_reorderQuantity",
            "title" : "Reorder Quantity",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "daysToShip",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_daysToShip",
            "title" : "Days To Ship",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            name:"stockCalcs",
            title:"Stock Calcs",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "offsetQOHQtyAvailable",
                    "title" : "QOH minus Min Stock"
                }, {
                    "name" : "offsetATPQtyAvailable",
                    "title" : "ATP minus Min Stock"
                } 
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "offsetQOHQtyAvailable",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_offsetQOHQtyAvailable",
            "title" : "QOH minus Min Stock",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "offsetATPQtyAvailable",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_offsetATPQtyAvailable",
            "title" : "ATP minus Min Stock",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityUom",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_quantityUom",
            "title" : "Quantity UomId",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "usageQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_usageQuantity",
            "title" : "Usage",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            name:"prices",
            title:"Prices",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "defaultPrice",
                    "title" : "Default Price"
                }, {
                    "name" : "listPrice",
                    "title" : "List Price"
                }, {
                    "name" : "wholeSalePrice",
                    "title" : "Whole Sale Price"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "defaultPrice",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_defaultPrice",
            "title" : "Default Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "listPrice",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_listPrice",
            "title" : "List Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "wholeSalePrice",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_wholeSalePrice",
            "title" : "Whole Sale Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"sellThrough",
            title:"Sell Through",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "fromDateSellThrough",
                    "title" : "From Date Sell Through"
                }, {
                    "name" : "sellThroughInitialInventory",
                    "title" : "Sell Through Initial Inventory"
                }, {
                    "name" : "sellThroughInventorySold",
                    "title" : "Sell Through Inventory Sold"
                }, {
                    "name" : "sellThroughPercentage",
                    "title" : "Sell Through Percentage"
                } 
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDateSellThrough",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_fromDateSellThrough",
            "title" : "From Date Sell Through",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sellThroughInitialInventory",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_sellThroughInitialInventory",
            "title" : "Sell Through Initial Inventory",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sellThroughInventorySold",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_sellThroughInventorySold",
            "title" : "Sell Through Inventory Sold",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sellThroughPercentage",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryByProduct_sellThroughPercentage",
            "title" : "Sell Through Percentage",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "inventoryItemTypeId", "statusId", "datetimeReceived", "expireDate", "productId", "internalName", "partyId", "locationSeqId", "enumId", "lotId", "binNumber", "serialNumber", "softIdentifier", "quantityOnHandTotal", "transfer" ]
        } ],
        "columns" : [ {
            "name" : "inventoryItemId",
            "title" : "Inventory Item ID"
        }, {
            "name" : "inventoryItemTypeId",
            "title" : "InventoryItem Type ID"
        }, {
            "name" : "statusId",
            "title" : "Status ID"
        }, {
            "name" : "datetimeReceived",
            "title" : "Date Time Received"
        }, {
            "name" : "expireDate",
            "title" : "Expire Date"
        }, {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "internalName",
            "title" : "Internal Name"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "locationSeqId",
            "title" : "Location Seq ID"
        }, {
            "name" : "enumId",
            "title" : "CommonType"
        }, {
            "name" : "lotId",
            "title" : "Lot ID"
        }, {
            "name" : "binNumber",
            "title" : "Bin Number"
        }, {
            "name" : "serialNumber",
            "title" : "Serial Number"
        }, {
            "name" : "softIdentifier",
            "title" : "Soft Identifier"
        }, {
            "name" : "quantityOnHandTotal",
            "title" : "Quantity On Hand Total"
        }, {
            "name" : "transfer",
            "title" : "Transfer"
        } ],
        "formName" : "ListFacilityInventoryItems",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Inventory Item ID",
            "type" : "HYPERLINK",
            "target" : "EditInventoryItem",
            "name" : "inventoryItemId",
            "width" : "",
            "parameterList" : [ {
            "name" : "inventoryItemId"
            }, {
            "name" : "facilityId"
            } ],
            "style" : "",
            "id" : "ListFacilityInventoryItems_inventoryItemId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"EditInventoryItem",
                "formLocation":"component://kwikstore/widget/FacilityForms.xml"
            },
            "event":"list"
        }, {
            name:"itemDetail",
            title:"Item Detail",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "inventoryItemTypeId",
                    "title" : "InventoryItem Type ID"
                }, {
                    "name" : "statusId",
                    "title" : "Status ID"
                }, {
                    "name" : "datetimeReceived",
                    "title" : "Date Time Received"
                }, {
                    "name" : "expireDate",
                    "title" : "Expire Date"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inventoryItemTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_inventoryItemTypeId",
            "title" : "InventoryItem Type ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_statusId",
            "title" : "Status ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "datetimeReceived",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_datetimeReceived",
            "title" : "Date Time Received",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "expireDate",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_expireDate",
            "title" : "Expire Date",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"productDetail",
            title:"Product Detail",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "productId",
                    "title" : "Product ID"
                }, {
                    "name" : "internalName",
                    "title" : "Internal Name"
                }, {
                    "name" : "partyId",
                    "title" : "Party ID"
                } 
            ]
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product ID",
            "type" : "HIDDEN",
            "target" : "/catalog/control/EditProduct",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListFacilityInventoryItems_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "internalName",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_internalName",
            "title" : "Internal Name",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_partyId",
            "title" : "Party ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:'locationDetails',
            title:"Location Details",
            type:"COMPOSITE",
            innerfields:[
                {
                    "name" : "locationSeqId",
                    "title" : "Location Seq ID"
                }, {
                    "name" : "enumId",
                    "title" : "CommonType"
                }, {
                    "name" : "lotId",
                    "title" : "Lot ID"
                }, {
                    "name" : "binNumber",
                    "title" : "Bin Number"
                }
            ]
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Location Seq ID",
            "type" : "HIDDEN",
            "target" : "EditFacilityLocation",
            "name" : "locationSeqId",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            }, {
            "name" : "locationSeqId"
            } ],
            "style" : "",
            "id" : "ListFacilityInventoryItems_locationSeqId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "enumId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_enumId",
            "title" : "CommonType",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "lotId",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_lotId",
            "title" : "Lot ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "binNumber",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_binNumber",
            "title" : "Bin Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"identifiers",
            title:"Identifiers",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "serialNumber",
                    "title" : "Serial Number"
                }, {
                    "name" : "softIdentifier",
                    "title" : "Soft Identifier"
                }
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "serialNumber",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_serialNumber",
            "title" : "Serial Number",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "softIdentifier",
            "description" : "",
            "style" : "",
            "id" : "ListFacilityInventoryItems_softIdentifier",
            "title" : "Soft Identifier",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityOnHandTotal",
            "description" : " / ",
            "style" : "",
            "id" : "ListFacilityInventoryItems_quantityOnHandTotal",
            "title" : "Quantity On Hand Total",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Transfer",
            "title" : "Transfer",
            "type" : "HYPERLINK",
            "target" : "TransferInventoryItem",
            "name" : "transfer",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            }, {
            "name" : "inventoryItemId"
            } ],
            "style" : "",
            "id" : "ListFacilityInventoryItems_transfer",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "formData":{
                "formName":"TransferInventoryItem",
                "formLocation":"component://kwikstore/widget/FacilityForms.xml"
            },
            "event":"edit"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "inventoryItemTypeId", "productId", "partyId", "ownerPartyId", "statusId", "statusId", "statusId", "datetimeReceived", "datetimeManufactured", "expireDate", "facilityId", "containerId", "lotId", "uomId", "binNumber", "locationSeqId", "comments", "accountingQuantityTotal", "serialNumber", "softIdentifier", "activationNumber", "activationValidThru", "unitCost", "currencyUomId", "fixedAssetId", "totals", "submit", "submit", "oldQuantityOnHand", "oldAvailableToPromise" ]
        } ],
        "formName" : "EditInventoryItem",
        "altTarget" : [ {
            "useWhen" : "inventoryItemId==null",
            "targetExdr" : {
            "chars" : "CreateInventoryItem",
            "hint" : 20,
            "empty" : false,
            "original" : "CreateInventoryItem"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/InventoryForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "inventoryItemId",
            "action" : "",
            "id" : "EditInventoryItem_inventoryItemId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "accountingQuantityTotal",
            "action" : "",
            "id" : "EditInventoryItem_accountingQuantityTotal",
            "type" : "DISPLAY",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inventoryItemId",
            "description" : "",
            "style" : "",
            "id" : "EditInventoryItem_inventoryItemId",
            "title" : "Inventory Item ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "InventoryItem Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditInventoryItem",
            "options" : [ {
            "description" : "Serialized",
            "key" : "SERIALIZED_INV_ITEM"
            }, {
            "description" : "Non-Serialized",
            "key" : "NON_SERIAL_INV_ITEM"
            } ],
            "disabled" : "false",
            "id" : "EditInventoryItem_inventoryItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "inventoryItemTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditInventoryItem",
            "id" : "EditInventoryItem_productId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productId",
            "style" : "",
            "id" : "EditInventoryItem_productId",
            "title" : "Product ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditInventoryItem",
            "id" : "EditInventoryItem_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "EditInventoryItem_partyId",
            "title" : "Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditInventoryItem",
            "id" : "EditInventoryItem_ownerPartyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "ownerPartyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "ownerPartyId",
            "style" : "",
            "id" : "EditInventoryItem_ownerPartyId",
            "title" : "Owner Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditInventoryItem",
            "options" : [ {
            "description" : "On Hold (Non-Serialized)",
            "key" : "INV_NS_ON_HOLD"
            }, {
            "description" : "Defective (Non-Serialized)",
            "key" : "INV_NS_DEFECTIVE"
            }, {
            "description" : "Returned (Non-Serialized)",
            "key" : "INV_NS_RETURNED"
            }, {
            "description" : "On Order",
            "key" : "INV_ON_ORDER"
            }, {
            "description" : "Available",
            "key" : "INV_AVAILABLE"
            }, {
            "description" : "Promised",
            "key" : "INV_PROMISED"
            }, {
            "description" : "Delivered",
            "key" : "INV_DELIVERED"
            }, {
            "description" : "Activated",
            "key" : "INV_ACTIVATED"
            }, {
            "description" : "Deactivated",
            "key" : "INV_DEACTIVATED"
            }, {
            "description" : "On Hold",
            "key" : "INV_ON_HOLD"
            }, {
            "description" : "Being Transfered",
            "key" : "INV_BEING_TRANSFERED"
            }, {
            "description" : "Being Transfered (Promised)",
            "key" : "INV_BEING_TRANS_PRM"
            }, {
            "description" : "Returned",
            "key" : "INV_RETURNED"
            }, {
            "description" : "Defective",
            "key" : "INV_DEFECTIVE"
            } ],
            "disabled" : "false",
            "id" : "EditInventoryItem_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Date Time Received",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-15%2016:04:09.307",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditInventoryItem",
            "timeDropdownParamName" : "datetimeReceived",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditInventoryItem_datetimeReceived",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "datetimeReceived",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Date Time Manufactured",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-15%2016:04:09.307",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditInventoryItem",
            "timeDropdownParamName" : "datetimeManufactured",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditInventoryItem_datetimeManufactured",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "datetimeManufactured",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Expire Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-15%2016:04:09.307",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditInventoryItem",
            "timeDropdownParamName" : "expireDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditInventoryItem_expireDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "expireDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "Facility ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditInventoryItem",
            "options" : [ {
            "description" : "Boskop",
            "key" : "10104"
            }, {
            "description" : "Boskop",
            "key" : "10107"
            }, {
            "description" : "Boskop",
            "key" : "10112"
            }, {
            "description" : "Boskop",
            "key" : "10113"
            }, {
            "description" : "China Store",
            "key" : "10041"
            }, {
            "description" : "China Store",
            "key" : "10060"
            }, {
            "description" : "China Store",
            "key" : "10070"
            }, {
            "description" : "China Store",
            "key" : "10097"
            }, {
            "description" : "China Store",
            "key" : "10099"
            }, {
            "description" : "China Store",
            "key" : "10100"
            }, {
            "description" : "China Store",
            "key" : "10102"
            }, {
            "description" : "China Store",
            "key" : "10111"
            }, {
            "description" : "China Store",
            "key" : "10118"
            }, {
            "description" : "Hierso",
            "key" : "10106"
            }, {
            "description" : "Mattress",
            "key" : "10090"
            }, {
            "description" : "Mattress",
            "key" : "10093"
            }, {
            "description" : "Mattress",
            "key" : "10096"
            }, {
            "description" : "Mattress",
            "key" : "10098"
            }, {
            "description" : "Mattress",
            "key" : "10103"
            }, {
            "description" : "Mattress",
            "key" : "10110"
            }, {
            "description" : "My Retail Store",
            "key" : "MyRetailStore"
            }, {
            "description" : "My Warehouse",
            "key" : "10105"
            }, {
            "description" : "My Warehouse",
            "key" : "10108"
            }, {
            "description" : "My Where House",
            "key" : "10000"
            }, {
            "description" : "My Where House",
            "key" : "10010"
            }, {
            "description" : "My Where House",
            "key" : "10020"
            }, {
            "description" : "My Where House",
            "key" : "10030"
            }, {
            "description" : "My Where House",
            "key" : "10040"
            }, {
            "description" : "My Where House",
            "key" : "10091"
            }, {
            "description" : "My Where House",
            "key" : "10092"
            }, {
            "description" : "My Where House",
            "key" : "10115"
            }, {
            "description" : "My Where House",
            "key" : "10116"
            }, {
            "description" : "My Where House",
            "key" : "10117"
            }, {
            "description" : "My Where House",
            "key" : "10119"
            }, {
            "description" : "My Where House",
            "key" : "10131"
            }, {
            "description" : "Regional Warehouse1",
            "key" : "RegionalWarehouse1"
            }, {
            "description" : "Regional Warehouse2",
            "key" : "RegionalWarehouse2"
            }, {
            "description" : "Store Here",
            "key" : "10080"
            }, {
            "description" : "Store Warehouse1",
            "key" : "StoreWarehouse1"
            }, {
            "description" : "Store Warehouse2",
            "key" : "StoreWarehouse2"
            }, {
            "description" : "Web Store Warehouse",
            "key" : "WebStoreWarehouse"
            }, {
            "description" : "YThere",
            "key" : "10050"
            }, {
            "description" : "YThere",
            "key" : "10094"
            }, {
            "description" : "YThere",
            "key" : "10095"
            }, {
            "description" : "YThere",
            "key" : "10101"
            }, {
            "description" : "YThere",
            "key" : "10109"
            }, {
            "description" : "YThere",
            "key" : "10114"
            }, {
            "description" : "YThere",
            "key" : "10120"
            }, {
            "description" : "YThere",
            "key" : "10130"
            } ],
            "disabled" : "false",
            "id" : "EditInventoryItem_facilityId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "facilityId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Container ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "containerId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_containerId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Lot ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lotId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_lotId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Uom ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "uomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_uomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Bin Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "binNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_binNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditInventoryItem",
            "id" : "EditInventoryItem_locationSeqId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupFacilityLocation",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "locationSeqId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "locationSeqId",
            "style" : "",
            "id" : "EditInventoryItem_locationSeqId",
            "title" : "Facility Location",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "accountingQuantityTotal",
            "description" : "",
            "style" : "",
            "id" : "EditInventoryItem_accountingQuantityTotal",
            "title" : "Accounting Quantity Total",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Serial Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "serialNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_serialNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Soft Identifier",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "softIdentifier",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_softIdentifier",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Activation Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "activationNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_activationNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Activation Valid Through",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-15%2016:04:09.321",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditInventoryItem",
            "timeDropdownParamName" : "activationValidThru",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditInventoryItem_activationValidThru",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "activationValidThru",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Unit Cost",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "unitCost",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_unitCost",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Currency",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "currencyUomId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_currencyUomId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Fixed Asset ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "fixedAssetId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditInventoryItem_fixedAssetId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditInventoryItem",
            "tabindex" : "",
            "name" : "submit",
            "className" : "",
            "id" : "EditInventoryItem_submit",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Create",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "UpdateInventoryItem"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "locationSeqId", "locationTypeEnum", "areaId", "aisleId", "sectionId", "levelId", "positionId" ]
        } ],
        "columns" : [ {
            "name" : "facilityId",
            "title" : "Facility"
        }, {
            "name" : "locationSeqId",
            "title" : "Location SeqID"
        }, {
            "name" : "locationTypeEnum",
            "title" : "Type"
        }, {
            "name" : "areaId",
            "title" : "Area"
        }, {
            "name" : "aisleId",
            "title" : "Aisle"
        }, {
            "name" : "sectionId",
            "title" : "Section"
        }, {
            "name" : "levelId",
            "title" : "Level"
        }, {
            "name" : "positionId",
            "title" : "Position"
        } ],
        "formName" : "FindFacilityLocations",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Facility",
            "type" : "HIDDEN",
            "target" : "EditFacility",
            "name" : "facilityId",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            } ],
            "style" : "",
            "id" : "FindFacilityLocations_facilityId",
            "imageTitle" : "",
            "parameterMap" : {
            "facilityId" : "WebStoreWarehouse"
            },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Location SeqID",
            "type" : "HIDDEN",
            "target" : "EditFacilityLocation",
            "name" : "locationSeqId",
            "width" : "",
            "parameterList" : [ {
            "name" : "facilityId"
            }, {
            "name" : "locationSeqId"
            } ],
            "style" : "",
            "id" : "FindFacilityLocations_locationSeqId",
            "imageTitle" : "",
            "parameterMap" : {
            "facilityId" : "WebStoreWarehouse"
            },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "locationTypeEnum",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_locationTypeEnum",
            "title" : "CommonType",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"locationDetails",
            title:"Details",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "facilityId",
                    "title" : "Facility"
                }, {
                    "name" : "locationSeqId",
                    "title" : "Location SeqID"
                }, {
                    "name" : "locationTypeEnum",
                    "title" : "Type"
                }
            ]

        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "areaId",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_areaId",
            "title" : "CommonArea",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "aisleId",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_aisleId",
            "title" : "${uiLabelMap.ProductAisle",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sectionId",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_sectionId",
            "title" : "Section",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "levelId",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_levelId",
            "title" : "Level",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "positionId",
            "description" : "",
            "style" : "",
            "id" : "FindFacilityLocations_positionId",
            "title" : "Position",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "locationSeqId", "locationTypeEnumId", "areaId", "aisleId", "sectionId", "levelId", "positionId", "submitButton", "submitButton" ]
        } ],
        "formName" : "EditFacilityLocation",
        "altTarget" : [ {
            "useWhen" : "facilityLocation==null",
            "targetExdr" : {
            "chars" : "CreateFacilityLocation",
            "hint" : 20,
            "empty" : false,
            "original" : "CreateFacilityLocation"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "facilityId",
            "action" : "",
            "id" : "EditFacilityLocation_facilityId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WebStoreWarehouse"
        }, {
            "conditionGroup" : "",
            "name" : "locationSeqId",
            "action" : "",
            "id" : "EditFacilityLocation_locationSeqId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "TLTLTLLL01"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditFacilityLocation",
            "options" : [ {
            "description" : "Bulk",
            "key" : "FLT_BULK"
            }, {
            "description" : "Pick/Primary",
            "key" : "FLT_PICKLOC"
            } ],
            "disabled" : "false",
            "id" : "EditFacilityLocation_locationTypeEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "locationTypeEnumId",
            "style" : "",
            "explicitDescription" : "Pick/Primary",
            "choices" : "",
            "currentValue" : "FLT_PICKLOC"
        }, {
            "" : "TL",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "CommonArea",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "areaId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacilityLocation_areaId",
            "placeholder" : "",
            "event" : "",
            "value" : "TL",
            "mask" : ""
        }, {
            "" : "TL",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Aisle",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "aisleId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacilityLocation_aisleId",
            "placeholder" : "",
            "event" : "",
            "value" : "TL",
            "mask" : ""
        }, {
            "" : "TL",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Section",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sectionId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacilityLocation_sectionId",
            "placeholder" : "",
            "event" : "",
            "value" : "TL",
            "mask" : ""
        }, {
            "" : "LL",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Level",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "levelId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacilityLocation_levelId",
            "placeholder" : "",
            "event" : "",
            "value" : "LL",
            "mask" : ""
        }, {
            "" : "01",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Position",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "positionId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditFacilityLocation_positionId",
            "placeholder" : "",
            "event" : "",
            "value" : "01",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditFacilityLocation",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "EditFacilityLocation_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "CommonUpdate",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "UpdateFacilityLocation"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productName", "description", "itemDescription", "inventoryItemTypeId", "ownerPartyId", "serialNumber", "partyId", "datetimeReceived", "lotId", "locationSeqId", "submitButton" ]
        } ],
        "formName" : "ReceiveSingleInventoryProduct",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_productId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "GZ-1004"
        }, {
            "conditionGroup" : "",
            "name" : "productName",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_productName",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "Rainbow Gizmo"
        }, {
            "conditionGroup" : "",
            "name" : "description",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_description",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "The only multi-colored gizmo"
        }, {
            "conditionGroup" : "",
            "name" : "ownerPartyId",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_ownerPartyId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "Company"
        }, {
            "conditionGroup" : "",
            "name" : "datetimeReceived",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_datetimeReceived",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "2025-01-20 16:19:27.959"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "GZ-1004",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_productId",
            "title" : "Product ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "Rainbow Gizmo",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_productName",
            "title" : "Product Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "The only multi-colored gizmo",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_description",
            "title" : "Product Description",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Item Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "itemDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_itemDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Inventory Item Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ {
            "description" : "Non-Serialized",
            "key" : "NON_SERIAL_INV_ITEM"
            }, {
            "description" : "Serialized",
            "key" : "SERIALIZED_INV_ITEM"
            } ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_inventoryItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "inventoryItemTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "ownerPartyId",
            "description" : "Company",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_ownerPartyId",
            "title" : "Owner",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Serial Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "serialNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_serialNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "${uiLabelMap.ProductSupplier",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_partyId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "partyId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "datetimeReceived",
            "description" : "2025-01-20 16:19:27.959",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_datetimeReceived",
            "title" : "Date Received",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "${uiLabelMap.lotId",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lotId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_lotId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Facility Location",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ {
            "description" : "TLTLTLLL01 [Pick/Primary]",
            "key" : "TLTLTLLL01"
            }, {
            "description" : "TLTLTLLL02 [Pick/Primary]",
            "key" : "TLTLTLLL02"
            }, {
            "description" : "TLTLTLLL02 [Pick/Primary]",
            "key" : "TLTLTLLL02"
            }, {
            "description" : "TLTLTLLL03 [Pick/Primary]",
            "key" : "TLTLTLLL03"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL02 [Bulk]",
            "key" : "TLTLTLUL02"
            }, {
            "description" : "TLTLTLUL03 [Bulk]",
            "key" : "TLTLTLUL03"
            }, {
            "description" : "TLTLTLUL04 [Bulk]",
            "key" : "TLTLTLUL04"
            } ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_locationSeqId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "locationSeqId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ReceiveSingleInventoryProduct",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "ReceiveSingleInventoryProduct_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "CommonReceive",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "receiveSingleInventoryProduct"
    },
    {
        "formName" : "ProductLookUp",
        "fields":[
            {
                "fieldHelpText" : "",
                "lookupOptions" : {
                "ajaxUrl" : "",
                "fadeBackground" : "true",
                "conditionGroup" : "",
                "targetParameterList" : [ "productId","internalName","description","brandName" ],
                "className" : "",
                "type" : "LOOKUP",
                "entityName":"Product",
                "presentation" : "layer",
                "initiallyCollapsed" : "false",
                "ajaxEnabled" : "true",
                "showDescription" : "true",
                "delegatorName" : "",
                "readonly" : "false",
                "alert" : "false",
                "formName" : "ProductLookUp",
                "id" : "ProductLookUp_productId",
                "event" : "",
                "value" : "",
                "fieldFormName" : "LookupProduct",
                "maxlength" : "",
                "autocomplete" : "",
                "clearText" : "Clear",
                "tabindex" : "",
                "size" : "25",
                "name" : "productId",
                "descriptionFieldName" : "internalName",
                "position" : "topleft",
                "imgSrc" : ""
                },
                "name" : "productId",
                "style" : "",
                "id" : "EditQuote_partyId",
                "title" : "Product ID",
                "type" : "LOOKUP"
            }
        ]
    },
    {
        "formName" : "OrderLookUp",
        "fields":[
            {
                "fieldHelpText" : "",
                "lookupOptions" : {
                "ajaxUrl" : "",
                "fadeBackground" : "true",
                "conditionGroup" : "",
                "targetParameterList" : [ "orderId","orderName" ],
                "className" : "",
                "type" : "LOOKUP",
                "entityName":"OrderHeader",
                "presentation" : "layer",
                "initiallyCollapsed" : "false",
                "ajaxEnabled" : "true",
                "showDescription" : "true",
                "delegatorName" : "",
                "readonly" : "false",
                "alert" : "false",
                "formName" : "OrderLookUp",
                "id" : "OrderLookUp_orderId",
                "event" : "",
                "value" : "",
                "fieldFormName" : "LookupOrderHeader",
                "maxlength" : "",
                "autocomplete" : "",
                "clearText" : "Clear",
                "tabindex" : "",
                "size" : "25",
                "name" : "orderId",
                "descriptionFieldName" : "orderId",
                "position" : "topleft",
                "imgSrc" : ""
                },
                "name" : "orderId",
                "style" : "",
                "id" : "OrderLookUp_orderId",
                "title" : "Order ID",
                "type" : "LOOKUP"
            }
        ]
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productName", "description", "itemDescription", "inventoryItemTypeId", "ownerPartyId", "serialNumber", "partyId", "datetimeReceived", "lotId", "locationSeqId", "submitButton" ]
        } ],
        "formName" : "ReceiveSingleInventoryProduct",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/FacilityForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_productId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "GZ-1004"
        }, {
            "conditionGroup" : "",
            "name" : "productName",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_productName",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "Rainbow Gizmo"
        }, {
            "conditionGroup" : "",
            "name" : "description",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_description",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "The only multi-colored gizmo"
        }, {
            "conditionGroup" : "",
            "name" : "ownerPartyId",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_ownerPartyId",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "Company"
        }, {
            "conditionGroup" : "",
            "name" : "datetimeReceived",
            "action" : "",
            "id" : "ReceiveSingleInventoryProduct_datetimeReceived",
            "type" : "DISPLAY",
            "event" : "",
            "value" : "2025-01-22 18:07:51.781"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "GZ-1004",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_productId",
            "title" : "Product ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "Rainbow Gizmo",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_productName",
            "title" : "Product Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "The only multi-colored gizmo",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_description",
            "title" : "Product Description",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Item Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "itemDescription",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_itemDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Inventory Item Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ {
            "description" : "Non-Serialized",
            "key" : "NON_SERIAL_INV_ITEM"
            }, {
            "description" : "Serialized",
            "key" : "SERIALIZED_INV_ITEM"
            } ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_inventoryItemTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "inventoryItemTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "ownerPartyId",
            "description" : "Company",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_ownerPartyId",
            "title" : "Owner",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Serial Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "serialNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_serialNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "${uiLabelMap.ProductSupplier",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_partyId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "partyId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "datetimeReceived",
            "description" : "2025-01-22 18:07:51.781",
            "style" : "",
            "id" : "ReceiveSingleInventoryProduct_datetimeReceived",
            "title" : "Date Received",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "${uiLabelMap.lotId",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "lotId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ReceiveSingleInventoryProduct_lotId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Facility Location",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ReceiveSingleInventoryProduct",
            "options" : [ {
            "description" : "TLTLTLLL01 [Pick/Primary]",
            "key" : "TLTLTLLL01"
            }, {
            "description" : "TLTLTLLL02 [Pick/Primary]",
            "key" : "TLTLTLLL02"
            }, {
            "description" : "TLTLTLLL02 [Pick/Primary]",
            "key" : "TLTLTLLL02"
            }, {
            "description" : "TLTLTLLL03 [Pick/Primary]",
            "key" : "TLTLTLLL03"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLLL04 [Pick/Primary]",
            "key" : "TLTLTLLL04"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL01 [Bulk]",
            "key" : "TLTLTLUL01"
            }, {
            "description" : "TLTLTLUL02 [Bulk]",
            "key" : "TLTLTLUL02"
            }, {
            "description" : "TLTLTLUL03 [Bulk]",
            "key" : "TLTLTLUL03"
            }, {
            "description" : "TLTLTLUL04 [Bulk]",
            "key" : "TLTLTLUL04"
            } ],
            "disabled" : "false",
            "id" : "ReceiveSingleInventoryProduct_locationSeqId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "locationSeqId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ReceiveSingleInventoryProduct",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "ReceiveSingleInventoryProduct_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "CommonReceive",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "receiveSingleInventoryProduct"
    }
]
